import { render, staticRenderFns } from "./AS_AboutMobileDropDown.vue?vue&type=template&id=a13001c8&scoped=true&"
import script from "./AS_AboutMobileDropDown.vue?vue&type=script&lang=js&"
export * from "./AS_AboutMobileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./AS_AboutMobileDropDown.vue?vue&type=style&index=0&id=a13001c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13001c8",
  null
  
)

export default component.exports